import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { getAuthToken } from '../../utils/auth';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from '../Header';
import Footer from '../Footer';
import ReactQuill from 'react-quill';
import 'quill/dist/quill.snow.css';
import { useLocation, useNavigate } from 'react-router-dom';
import logoIcon from '../../img/logo.png';
import { fetchSinglePost } from '../../utils/PostComponents';
import Loader from '../OtherComponents/Loader';

const Base_Url = process.env.REACT_APP_BASE_URL;

const EditPosts = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const fileInputRef = useRef(null);
    const [formData, setFormData] = useState([]);
    const [attachment, setAttachment] = useState(null);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [edit, setEditing] = useState(false);
    const [showImg, setShowImg] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const id = location.pathname.split('/').pop();

    useEffect(() => {
        fetchSinglePost(id, setFormData, setAttachment);
        setTimeout(() => {
            setLoading(false)
        }, 2000)
    }, [id, location.pathname])


    const handleEdit = () => {
        setDeleting(false);
        setEditing(true);
        setAttachment(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };

    const handleDelete = () => {
        setEditing(false);
        setDeleting(true);
        setAttachment(null);
        setFormData({ ...formData, attachment: null });
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };

    const modules = {
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ 'size': ['small', 'medium', 'large', 'huge'] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
            ['link'],
            [{ 'color': [] }, { 'background': [] }],
            ['clean']
        ],
    };

    const formats = [
        'header', 'font', 'size',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'color', 'background'
    ];


    const handlePostChange = e => {
        setErrors({ ...errors, [e.target.name]: '' });
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleFileChange = e => {
        const file = e.target.files[0];
        if (file && file instanceof File) {
            setAttachment(URL.createObjectURL(file)); // Create a local URL for the selected file
            setFormData({ ...formData, attachment: file });
            setShowImg(true)
        } else {
            setAttachment(null); // Clear the attachment if no file is selected
        }
    };

    const handleDescriptionChange = (value) => {
        if (!formData.title || !formData.amount) {
            return; 
        }
        if (errors?.description) {
            setErrors({ ...errors, description: '' });
        }
        setFormData({ ...formData, description: value });
    };


    const validatePostData = () => {
        const errors = {};
        if (!formData.title) errors.title = "Title is required";
        if (!formData.amount) errors.amount = "Amount is required";
        if (!formData.description) errors.description = "Description is required";
        return errors;
    };

    const handlePostSubmit = async e => {
        e.preventDefault();
        const validationErrors = validatePostData();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        } else {
            setErrors({});
            try {
                setLoading(true);
                const token = getAuthToken();
                if (token) {
                    const formDataToSend = new FormData();
                    formDataToSend.append('id', id);
                    formDataToSend.append('title', formData.title);
                    formDataToSend.append('amount', formData.amount);
                    formDataToSend.append('description', formData.description);
                    if (formData.attachment) {
                        formDataToSend.append('attachment', formData.attachment);
                    }
                    else {
                        if (deleting) {
                            const defaultAttachment = await fetch(logoIcon).then(res => res.blob());
                            formDataToSend.append('attachment', defaultAttachment, 'logo.png');
                        }
                        if (edit) {
                            formDataToSend.append('attachment', formData.attachment);
                        }
                    }

                    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                    await axios.post(`${Base_Url}/api/posts/edit-posts`, formDataToSend, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });
                    toast.success("Post updated successfully!");
                    setTimeout(() => {
                        setAttachment(null);
                        setFormData({ id: '', title: '', amount: '', description: '' });
                        setLoading(false);
                        navigate(-1);
                    }, 1000);
                }
            } catch (err) {
                console.error(err.response.data);
                setTimeout(() => {
                    setErrors({ server: "Failed to submit post. Please try again." });
                    toast.error("Failed to submit post. Please try again.");
                    setLoading(false);
                }, 1000);
            }
        }
    };

    return (
        <>
            <Header />
            <ToastContainer />
            <div className='topHeading'>
                <h2 className='heading'>Edit Post</h2>
            </div>
            {loading ? <Loader />
                :
                <div className="form-content">
                    <form onSubmit={handlePostSubmit} className='my-form'>
                        <input
                            type="text"
                            name="title"
                            placeholder="Title"
                            value={formData.title}
                            onChange={handlePostChange}
                            className={`form-control`}
                        />
                        {errors.title && <span className="text-danger">{errors.title}</span>}

                        <input
                            type="text"
                            name="amount"
                            placeholder="Amount"
                            value={formData.amount}
                            onChange={handlePostChange}
                            className={`form-control`}
                            style={{ marginBottom: '-10px' }}
                        />
                        <p style={{ marginBottom: '5px' }}><span className='text-danger'>Note* : Please enter amount in canadian dollars</span></p>

                        {errors.amount && <span className="text-danger">{errors.amount}</span>}

                        <ReactQuill
                            value={formData.description}
                            onChange={handleDescriptionChange}
                            modules={modules}
                            formats={formats}
                            className={`form-control`}
                            placeholder="Description"
                        />
                        {errors.description && <span className="text-danger">{errors.description}</span>}

                        {(!edit || !deleting || showImg) &&
                            <div className='image-preview'>
                                {attachment &&
                                    <div className="attachment-preview">
                                        <img src={attachment} alt="Attachment Preview" className="img-thumbnail" />
                                        <div className='image-btns'>
                                            <button type="button" className="edit-attachment" onClick={handleEdit}>Edit</button>
                                            <button type="button" className="delete-attachment" onClick={handleDelete}>Delete</button>
                                        </div>
                                    </div>
                                }
                            </div>
                        }

                        {(edit || deleting) &&
                            <>
                                <input
                                    type="file"
                                    name="attachment"
                                    onChange={handleFileChange}
                                    ref={fileInputRef} // Attach the ref here
                                    className={`form-control fileType ${errors.attachment && 'is-invalid'}`}
                                />
                                {errors.attachment && <span className="text-danger">{errors.attachment}</span>}
                            </>
                        }

                        <div className='submit-Post-div'>
                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                {!loading && 'Save'}
                            </button>

                            <button type="button" className="btn btn-primary" onClick={() => { navigate(-1) }}>
                                {!loading && 'Cancel'}
                            </button>
                        </div>
                        {errors.server && <span className="text-danger">{errors.server}</span>}
                    </form>
                </div>
            }
            <Footer />
        </>
    );
};

export default EditPosts;
